import axios from "./AxiosService";

export const getFile = async (url) =>
  await axios({
    url: url,
    method: "GET",
    responseType: "blob",
    headers: {
      Accept: "application/octet-stream"
    }
  });
